import { DailyCameraErrorType } from "@daily-co/daily-js";

export const getDeviceInUseErrorHeading = (
  type: DailyCameraErrorType,
): string => {
  switch (type) {
    case "cam-in-use":
      return "micCamCheck:cam.in.use.error.name";
    case "mic-in-use":
      return "micCamCheck:mic.in.use.error.name";
    case "cam-mic-in-use":
      return "micCamCheck:cam.mic.in.use.error.name";
    default:
      return "micCamCheck:default.camera.error";
  }
};

export const getDeviceInUseErrorName = (type: DailyCameraErrorType): string => {
  switch (type) {
    case "cam-in-use":
      return "micCamCheck:cam.in.use.error.name";
    case "mic-in-use":
      return "micCamCheck:mic.in.use.error.name";
    case "cam-mic-in-use":
      return "micCamCheck:cam.mic.in.use.error.name";
    case "constraints":
      return "micCamCheck:constraints.camera.error.name";
    case "undefined-mediadevices":
      return "micCamCheck:undefined.mediadevices.camera.error.name";
    case "unknown":
      return "micCamCheck:unknown.camera.error.name";
    default:
      return "micCamCheck:default.camera.error";
  }
};

export const getDevicePromptContent = (type: DailyCameraErrorType): string => {
  switch (type) {
    case "cam-in-use":
      return "micCamCheck:device.prompt.cam";
    case "mic-in-use":
      return "micCamCheck:device.prompt.mic";
    case "cam-mic-in-use":
      return "micCamCheck:device.prompt.mic.cam";
    default:
      return "micCamCheck:camera.error.troubleshoot";
  }
};

export const getStepOneOfDeviceError = (type: DailyCameraErrorType): string => {
  switch (type) {
    case "cam-in-use":
      return "micCamCheck:step.one.close.applications.using.cam";
    case "mic-in-use":
      return "micCamCheck:step.one.close.applications.using.mic";
    default:
      return "micCamCheck:step.one.close.applications.using.cam.mic";
  }
};
